import React, { useState, useEffect } from "react";
import ActionButtons from "../preapps/ActionButtonsForMerchant";
import PreapChildRow from "./child-row/child-row";
import PreapChildRowDefault from "./child-row/child-row-default";
import PreappStatusBar from "./status-bar/status-bar-for-merchant";

import PreappStatusBarParent from "./status-bar/status-bar-parent";
const PreappArow = ({
    activeId,
    user,
    row_info,
    defaultBank,
    default_index,
    pci_admin,
    t,
    status2Percentage,
    handleClick,
    currentStatus,
    handleStar,
    handleCancle,
    handlePdfRun,
    handleAppCopy,
    handleChangeOwner,
    showBanks,
    handleActiveBank,
    check,
    status2PercentageFn,
    handleClickWithChild,
    handleChildAppClick,
    show_info,
    currentProgressName,
}) => {
    const [showButtons, setShowButtons] = useState(false);
    const [pciAdmin, setPCIAdmin] = useState(false);

    useEffect(() => {
        setPCIAdmin(pci_admin);
    });

    const handleShowButtons = () => {
        setShowButtons(true);
    };

    const handleHideButtons = () => {
        setShowButtons(false);
    };
    const bindClassName = (data) => {
        if (data.child && data.child.length > 0) {
            return "has-child";
        } else {
            return "";
        }
    };

    const showChild = (data) => {
        if ((row_info && activeId === t[1].id) || getChildIndex(t[1])) {
            return "show";
        } else {
            return "";
        }
    };

    const getChildIndex = (parent) => {
        if (parent.child.length > 0) {
            const inChildAcive = parent.child.find((x) => x.id === activeId);
            if (inChildAcive) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    };
    return (
        <>
            <div
                className={
                    (check.includes("" + t[1].id + "") ||
                    activeId === t[1].id ||
                    getChildIndex(t[1])
                        ? "table-div-tr active "
                        : "table-div-tr ") +
                    " " +
                    bindClassName(t[1]) +
                    " " +
                    showChild(t[1])
                }
                key={t[0]}
            >
                <div
                    className={`table-div-tr-inner`}
                    onClick={(e) => handleClick(t[1].id, t[0])}
                    onMouseLeave={() => {
                        handleHideButtons();
                    }}
                    onMouseEnter={() => {
                        handleShowButtons();
                    }}
                >
                    <div
                        className={
                            user.role !== "agent"
                                ? "table-div-td col-merchant-dba col-merchant-newdba"
                                : "table-div-td col-merchant-dba dba-name-agent col-merchant-newdba"
                        }
                    >
                        <span title={t[1].field_dba || <>&mdash;</>}>
                            {t[1].field_dba || <>&mdash;</>}
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PreappArow;
